export function removePrefix(text: string, prefix: string) {
  return text.replace(new RegExp(`^${prefix}`), '');
}
